import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  Row,
  Button,
  Input,
} from "reactstrap";
import dummyImg from "../../../../assets/images/users/user-dummy-img.jpg";
import { Formik, useFormik } from "formik";
import * as Yup from "yup";
import BreadCrumb from "../../../../Components/Common/BreadCrumb/BreadCrumb";
import { useTranslation } from "react-i18next";
import PhoneInput from "react-phone-number-input";

const Profile = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const currentUser = JSON.parse(sessionStorage.getItem("authUser"));

  const [activeTab, setActiveTab] = useState("1");
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };
  // Example form validation schema with Yup (you can customize this)
  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    adress: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
  });

  // Formik hook for handling form data and validation
  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      address: "",
    },
    validationSchema,
    onSubmit: (values) => {
      // Handle form submission logic here
      console.log(values);
    },
  });

  return (
    <Container fluid>
      <BreadCrumb title="User Profile" />

      <Row>
        <Col lg="12">
          <Card>
            <Row>
              <Col style={{ marginLeft: "15px", marginTop: "15px" }}>
                <Button
                  onClick={handleGoBack}
                  className="bordered-btn-light"
                  color="light"
                >
                  {t("parametre.return")}
                </Button>
              </Col>
              <Col>
                <div className="param"> {t("parametre.parametres")}</div>
              </Col>
            </Row>

            <CardBody>
              <Form>
                <div className="center-container">
                  <Card className="center-card">
                    <CardHeader>
                      <div className="profil"> {t("parametre.profil")}</div>
                    </CardHeader>
                    <CardBody>
                      <span className="photo">{t("parametre.photo")}</span>
                      <div className="">
                        <img
                          src={dummyImg}
                          alt="User Profile"
                          className="rounded-circle"
                          width="71"
                          height="71"
                        />
                      </div>
                      <div className="mb-3">
                        <label
                          htmlFor="firstName"
                          className="form-labelProfile"
                        >
                          {t("driverForm.nom")}
                        </label>
                        <Input
                          type="text"
                          id="firstName"
                          name="firstName"
                          className="text-input"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={currentUser?.fullName}
                          required
                        />
                        {formik.touched.firstName &&
                          formik.errors.firstName && (
                            <div className="text-danger">
                              {formik.errors.firstName}
                            </div>
                          )}
                      </div>

                      <div className="mb-3">
                        <label htmlFor="email" className="form-labelProfile">
                          {t("driverForm.email")}
                        </label>
                        <Input
                          type="email"
                          id="email"
                          name="email"
                          className="text-input"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={currentUser?.email}
                        />
                        {formik.touched.email && formik.errors.email && (
                          <div className="text-danger">
                            {formik.errors.email}
                          </div>
                        )}
                      </div>
                      <div className="mb-3">
                        <label htmlFor="phone" className="form-labelProfile">
                          {t("driverForm.phone")}
                        </label>
                        <PhoneInput
                          international
                          defaultCountry="SN"
                          value={currentUser?.phone}
                          onChange={(value) =>
                            formik.setFieldValue("phone", value)
                          }
                          onBlur={formik.handleBlur}
                          id="phone"
                          name="phone"
                          className="form-control"
                        />
                        {formik.touched.phone && formik.errors.phone && (
                          <div className="text-danger">
                            {formik.errors.phone}
                          </div>
                        )}
                      </div>
                    </CardBody>
                  </Card>
                </div>
              </Form>

              <div className="center-container">
                <Card className="center-card">
                  <CardHeader>
                    <div className="profil">
                      {" "}
                      {t("parametre.notifications")}
                    </div>
                  </CardHeader>
                  <CardBody></CardBody>
                </Card>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Profile;
